/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalitybigfiveagreeablenessleft4Inputs */



/**
* | output |
* | --- |
* | "Loner" |
*
* @param {Personalitybigfiveagreeablenessleft4Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalitybigfiveagreeablenessleft4 = /** @type {((inputs?: Personalitybigfiveagreeablenessleft4Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalitybigfiveagreeablenessleft4Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Loner")
	if (locale === "es") return /** @type {LocalizedString} */ ("Solitario")
	return /** @type {LocalizedString} */ ("Одиночка")
});
export { personalitybigfiveagreeablenessleft4 as "personalityBigFiveAgreeablenessLeft" }